module.exports = __webpack_public_path__ + "img/tittle_zh.0e1fe382.png";